import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=3ab228ed&scoped=true&"
import script from "./CommentCard.vue?vue&type=script&lang=js&"
export * from "./CommentCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=3ab228ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab228ed",
  null
  
)

export default component.exports